import React from 'react';
import {Grid} from '@mui/material';

function ColumnLayout({
    children,
    width,
    reverse,
    center,
    style,
    height,
    className,
    spacing,
    ...rest
}) {
    let direction = "column";
    if (reverse) {
        direction = "column-reverse";
    }

    const childrenCount = React.Children.count(children);

    return (
        <div className={className} style={{ width, height, ...style }}>
            <Grid container alignItems={center ? "center" : undefined} direction={direction} style={{ height: '100%' }} {...rest}>
                {
                    React.Children.map(children, (child, index) => (
                        <React.Fragment key={index}>
                            <Grid item>
                                { child }
                            </Grid>
                            {
                                spacing && (index !== childrenCount) && <span style={{ height: spacing, display: 'inline-block' }} />
                            }
                        </React.Fragment>
                    ))
                }
            </Grid>
        </div>
    );
}

// const useStyles = makeStyles({
//     root: {
//         // display: 'flex',
//         // flexDirection: 'column',
//         // justifyContent: 'center'
//     },
//     child: {
//         height: '100%'
//     }
// })

export default React.memo(ColumnLayout);